import {computed, decorate, observable} from 'mobx';

export const officeContext = 'office';
export const operatorContext = 'operator';

export const defaultContext = {
  isLoginRequired: false,
};

export class ContextStore {
  current = defaultContext;

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  get isOfficeContext() {
    return this.current.name === officeContext;
  }

  get isOperatorContext() {
    return this.current.name === operatorContext;
  }
}

decorate(ContextStore, {
  current: observable,
  isOfficeContext: computed,
  isOperatorContext: computed,
});
